import EffectCtr from "../../longhudou/module/longhudou_table_effect";

const { ccclass, property } = cc._decorator;
export enum EffectName {
    StartBetTips,
    EndBetTips,
    StartVs,
    TipsBet,
    ResultHu,
    ResultLong,
    ResultHe,
    FaPai,
    NaoZhong,
    XiPai,
    JuShu,
    Result,
    FaPaiBank,
    FaPaiPlayer,
    FanPai,
    PlayerWin,
    BankerWin,
    HeWin,
    ResultEnd,
    FaPaiEnd,
    PlayerDuizi,
    BankerDuizi,
    XiPaiAmin,
}

@ccclass
export default class BJLEffectCtr extends EffectCtr {


    @property(cc.Animation)
    result:cc.Animation = null //结算大截面

    @property(cc.Animation)
    bankerFaPai:cc.Animation = null 

    @property(cc.Animation)
    playerFaPai:cc.Animation = null

    @property(dragonBones.ArmatureDisplay)
    playerWin:dragonBones.ArmatureDisplay = null

    @property(dragonBones.ArmatureDisplay)
    bankerWin:dragonBones.ArmatureDisplay = null

    @property(dragonBones.ArmatureDisplay)
    heWin:dragonBones.ArmatureDisplay = null

    @property(dragonBones.ArmatureDisplay)
    xiPaiAmin:dragonBones.ArmatureDisplay = null

    @property(cc.Animation)
    pokerAmin:cc.Animation[] = []

    @property(cc.Animation)
    playerDuizi:cc.Animation = null

    @property(cc.Animation)
    bankerDuizi:cc.Animation = null

    @property(cc.Node)
    playerLine:cc.Node = null

    @property(cc.Node)
    bankerLine:cc.Node = null

    playerDuiziPos = null
    bankerDuiziPos = null

    pokerAminPos = []
    start(){
        for (let index = 0; index < this.pokerAmin.length; index++) {
            const element = this.pokerAmin[index];
            this.pokerAminPos[index] = element.node.position
        }
        this.playerDuiziPos = this.playerDuizi.node.position
        this.bankerDuiziPos = this.bankerDuizi.node.position
    }


    playEffectAnim(playType:EffectName, callBack:Function = null, cName:string = null, isHide:boolean = false, time:number = 0, loopTimes: number = -1){
        let animList = []
        let currentAnimation = null
        let effect_Name = cName
        switch(playType){
            case EffectName.StartBetTips:
                currentAnimation = this.startBetTips
                break;
            case EffectName.EndBetTips:
                currentAnimation = this.endBetTips
                break;
            case EffectName.StartVs:
                currentAnimation = this.startVs
                break;
            case EffectName.NaoZhong:
                currentAnimation = this.naozhong
                break
            case EffectName.FaPai:
                effect_Name = "anim_fapai"
                currentAnimation = this.fapai
                break
            case EffectName.FaPaiEnd:
                effect_Name = "anim_fapai_hold"
                currentAnimation = this.fapai
                break
            case EffectName.XiPai:
                currentAnimation = this.xiPai
                break
            case EffectName.JuShu:
                currentAnimation = this.juShu
                break
            case EffectName.Result:
                currentAnimation = this.result
                effect_Name = "anim_bjl_jiesuan"
                break
            case EffectName.FaPaiBank:
                currentAnimation = this.bankerFaPai
                break
            case EffectName.FaPaiPlayer:
                currentAnimation = this.playerFaPai
                break
            case EffectName.FanPai:
                currentAnimation = this.fapai
                effect_Name = "anim_fapai2"
                break
            case EffectName.PlayerWin:
                currentAnimation = this.playerWin
                effect_Name = "play1"
                break
            case EffectName.BankerWin:
                currentAnimation = this.bankerWin
                effect_Name = "play1"
                break
            case EffectName.HeWin:
                currentAnimation = this.heWin
                effect_Name = "play1"
                break
            case EffectName.ResultEnd:
                currentAnimation = this.result
                effect_Name = "anim_bjl_jiesuan_shouhui"
                break
            case EffectName.PlayerDuizi:
                currentAnimation = this.playerDuizi
                break
            case EffectName.BankerDuizi:
                currentAnimation = this.bankerDuizi
                break
            case EffectName.XiPaiAmin:
                currentAnimation = this.xiPaiAmin
                effect_Name = "newAnimation"
                break
            default:
                break;
        }


        if (currentAnimation != null ){
            currentAnimation.targetOff && currentAnimation.targetOff(this)
            currentAnimation.on("stop", ()=> {                    
                if (callBack != null) { 
                    if (time > 0){
                        this.scheduleOnce(()=>{
                            callBack()
                            currentAnimation.node.active = isHide
                        }, time)
                    }
                    else{
                        callBack()
                        currentAnimation.node.active = isHide
                    }
                } 
            }, this)
            currentAnimation.node.active = true
            if(currentAnimation instanceof dragonBones.ArmatureDisplay){                
                currentAnimation.playAnimation(effect_Name, loopTimes)
            }else{
                currentAnimation.play(effect_Name)
            }
            for (let index = 0; index < animList.length; index++) {
                const element = animList[index];
                if(element.obj instanceof dragonBones.ArmatureDisplay){
                    
                    element.obj.playAnimation(element.clipName, loopTimes)
                }else{
                    element.obj.play(element.clipName)
                }
            }
        }
    }


    playPokerListByIndex(index, callBack){
        let currentAnimation = this.pokerAmin[index]
        if (currentAnimation != null){
            currentAnimation.targetOff && currentAnimation.targetOff(this)
            currentAnimation.on("finished", ()=> {                    
                if (callBack != null) { 
                    callBack()
                } 
            }, this)
            //currentAnimation.node.opacity = true
            currentAnimation.play()
        }
    }

    clearPokers(){
        for (let index = 0; index < this.pokerAmin.length; index++) {
            const element = this.pokerAmin[index];
            element.node.opacity = 0
            element.node.position = this.pokerAminPos[index]
        }
        this.playerDuizi.node.active = false
        this.bankerDuizi.node.active = false
        this.playerDuizi.node.position = this.playerDuiziPos
        this.bankerDuizi.node.position = this.bankerDuiziPos
        this.playerLine.active = false
        this.bankerLine.active = false
    }


    
}